import { Provider } from "components/relation/RelationContext";
import { RelationList } from 'components/relation/RelationList';

export const Relations = () => {
    return (
        <Provider>
            <RelationList />
        </Provider>
    );
};
